export enum SideNavStreamType {
  Collections = 1,
  ReadingLists = 2,
  Bookmarks = 3,
  Library = 4,
  SmartFilter = 5,
  ExternalSource = 6,
  AllSeries = 7,
  WantToRead = 8,
}
